import { render } from "./LotteryNew.vue?vue&type=template&id=d2c6436e&scoped=true"
import script from "./LotteryNew.vue?vue&type=script&lang=js"
export * from "./LotteryNew.vue?vue&type=script&lang=js"

import "./LotteryNew.vue?vue&type=style&index=0&id=d2c6436e&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c6436e"]])

export default __exports__